import { Select } from 'antd'
import React, { Component } from 'react'
import { PricingAPI } from '../../controller/PricingAPI'

export class HotelSelect extends Component {
    state = {
        hotels: [],
    }
    componentDidMount() {
        this.setState({ loading: true });
        PricingAPI.hotels.index({}, 1, 999).then((response) => {
            const result = response.data;
            this.setState({ hotels: result.data });
        });
        this.setState({ loading: false });
    }
    render() {
        return (
            <Select
                loading={this.state.loading}
                style={{ minWidth: 300 }}
                allowClear={true}
                showSearch
                placeholder="搜尋飯店..."
                filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                {...this.props}
            >
                {this.state.hotels.map((hotel) => <Select.Option key={hotel.id}>{hotel.name}</Select.Option>)}
            </Select>
        )
    }
}

export default HotelSelect